module.exports = __webpack_public_path__ + "img/video-control--next15.cc33b5d1.svg";